import { InjectionToken } from '@angular/core';
import type { AppEnvironment } from './environment.model';

export const APP_ENV = new InjectionToken<AppEnvironment>('APP_ENV');
